import { render, staticRenderFns } from "./PFormInputFile.vue?vue&type=template&id=53c488dd&scoped=true"
import script from "./PFormInputFile.vue?vue&type=script&lang=ts"
export * from "./PFormInputFile.vue?vue&type=script&lang=ts"
import style0 from "./PFormInputFile.vue?vue&type=style&index=0&id=53c488dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c488dd",
  null
  
)

export default component.exports